<template>
    <div class="message-container">
        <div class="icon">
            <img src="@/assets/img/check-green.png" alt="Ícone de sucesso">
        </div>
        <div class="text">Deu certo!</div>
    </div>
</template>

<script>
export default{
    name: 'SucessoCaptura',
    mounted(){
        this.$store.dispatch("setTitulo", "Confirmar identidade");
        this.$store.dispatch("setLoadingStatus", false);
        let doc_a = sessionStorage.getItem("A");
        let doc_b = sessionStorage.getItem("B");
        let tipo_captura = this.$store.getters.tipoCaptura;
        setTimeout(() => {
            let name = (tipo_captura === 1 && (!doc_a || !doc_b)) ?  "DocSelecao" : "Analise";
            this.$router.push({ name: name });
        }, 2000);
    }
};
</script>

<style scoped>
.message-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 80vh;
    text-align: center;
    padding: 20px;
}

.icon img{
    width: 30%;
}

.text{
    font-size: 20px;
}

</style>


// WEBPACK FOOTER //
// src/components/shared/SucessoCaptura.vue